import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { useIntl } from "../../../../shared/core/i18n/use-intl";
import { Path } from "../../../core/routing/path";
import { ActionRow, ActionRowList } from "../../common/action-row";
import { PageHeaderBand, PageHeaderSubtitle, PageHeaderTitle } from "../../common/page/page-header-band";
import { StaticAssets } from "../../styles/custom-assets";
import { theme } from "../../styles/theme";

/**
 * The landing page of the menu's "Profil et paramètres": the account's two settings screens, each
 * behind a row, rather than one of them being reachable only through the avatar's popup.
 */
export function ProfileMenuScreen() {
  const { formatMessage } = useIntl();
  const { push } = useHistory();

  return (
    <>
      <PageHeaderBand>
        <PageHeaderTitle>{formatMessage("profileMenu.title")}</PageHeaderTitle>
        <PageHeaderSubtitle>{formatMessage("profileMenu.subtitle")}</PageHeaderSubtitle>
      </PageHeaderBand>
      <SectionTitle>{formatMessage("profileMenu.generalSection")}</SectionTitle>
      <ActionRowList>
        <ActionRow
          iconSrc={StaticAssets.profileProfile}
          label={formatMessage("profileMenu.profileTitle")}
          subtitle={formatMessage("profileMenu.profileSubtitle")}
          onClick={() => push(Path.Profile)}
        />
        <ActionRow
          iconSrc={StaticAssets.profileSettings}
          label={formatMessage("profileMenu.settingsTitle")}
          subtitle={formatMessage("profileMenu.settingsSubtitle")}
          onClick={() => push(Path.Settings)}
        />
      </ActionRowList>
    </>
  );
}

const SectionTitle = styled.h2`
  ${theme.mediumText};
  margin: 0 0 12px;
  font-size: 20px;
  line-height: 26px;
  color: ${theme.colors.blue[800]};
`;
